import Vue from 'vue';
import VueCurrencyInput from 'vue-currency-input';

Vue.use(VueCurrencyInput, {
    globalOptions: {
        currency: 'EUR',
        decimalLength: 2,
        distractionFree: { hideNegligibleDecimalDigits: true, hideCurrencySymbol: true, hideGroupingSymbol: true },
    },
});
